import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './Forum.css';
import './PageShell.css';

const FORUM_TEXT = {
  zh: {
    loading: '加载中...',
    title: '社区论坛',
    subtitle: '交流经验，共同成长，分享你的故事',
    create: '+ 发新帖',
    sections: '讨论板块',
    latestPrefix: '最新：',
    posts: '帖子',
    recent: '最新帖子',
    emptyRecent: '暂无帖子，快来发第一帖',
    rules: '社区公约',
    ruleItems: ['尊重他人，友善交流', '禁止发布广告垃圾信息', '遵守法律法规', '保护个人隐私'],
  },
  en: {
    loading: 'Loading...',
    title: 'Community Forum',
    subtitle: 'Share experience, ask questions, and grow with other members.',
    create: '+ New post',
    sections: 'Discussion boards',
    latestPrefix: 'Latest:',
    posts: 'Posts',
    recent: 'Recent posts',
    emptyRecent: 'No posts yet. Start the first discussion.',
    rules: 'Community rules',
    ruleItems: ['Be respectful and constructive', 'No spam or unsolicited ads', 'Follow applicable laws', 'Protect personal privacy'],
  },
};

const CATEGORY_COPY = {
  en: {
    '经验分享': 'Experience sharing',
    '分享工作经验、接单技巧': 'Work experience, delivery tips, and client communication.',
  },
};

export default function Forum() {
  const { language } = useLanguage();
  const text = FORUM_TEXT[language] || FORUM_TEXT.en;
  const [categories, setCategories] = useState([]);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get('/forum/categories'), api.get('/forum/recent')])
      .then(([c, r]) => { setCategories(c.data); setRecent(r.data); })
      .finally(() => setLoading(false));
  }, []);

  const localize = value => (language === 'en' ? CATEGORY_COPY.en[value] || value : value);

  if (loading) return <div className="loading">{text.loading}</div>;

  return (
    <div className="forum-page page-shell-page">
      <div className="forum-banner">
        <div className="forum-banner-blob" />
        <div className="container forum-banner-inner">
          <div>
            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>
          </div>
          <Link to="/forum/post/create" className="btn btn-primary btn-lg">{text.create}</Link>
        </div>
      </div>

      <div className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
        <div className="forum-layout">
          <div>
            <div className="forum-section-title">{text.sections}</div>
            <div className="forum-cats">
              {categories.map(cat => (
                <Link key={cat.id} to={`/forum/categories/${cat.id}`} className="forum-cat-card">
                  <div className="fcc-icon">{cat.icon}</div>
                  <div className="fcc-info">
                    <div className="fcc-name">{localize(cat.name)}</div>
                    <div className="fcc-desc">{localize(cat.description)}</div>
                    {cat.last_post && (
                      <div className="fcc-last">
                        {text.latestPrefix} <span>{cat.last_post.title}</span> · {cat.last_post.username}
                      </div>
                    )}
                  </div>
                  <div className="fcc-count">
                    <strong>{cat.post_count}</strong>
                    <span>{text.posts}</span>
                  </div>
                  <div className="fcc-arrow">→</div>
                </Link>
              ))}
            </div>
          </div>

          <div className="forum-sidebar">
            <div className="card sidebar-card">
              <div className="sidebar-title">{text.recent}</div>
              {recent.length === 0 ? (
                <p style={{ color: '#94a3b8', fontSize: 13 }}>{text.emptyRecent}</p>
              ) : (
                recent.map(p => (
                  <Link key={p.id} to={`/forum/posts/${p.id}`} className="sidebar-post-item">
                    <span className="spi-icon">{p.category_icon}</span>
                    <div>
                      <div className="spi-title">{p.title}</div>
                      <div className="spi-meta">{p.author_name} · {p.reply_count} 回复</div>
                    </div>
                  </Link>
                ))
              )}
            </div>

            <div className="card sidebar-card" style={{ marginTop: 16 }}>
              <div className="sidebar-title">{text.rules}</div>
              <ul className="rules-list">
                {text.ruleItems.map(item => <li key={item}>{item}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
